import React from 'react';
import { GiftIcon, ImageIcon } from 'lucide-react';
import { bonuses, bonusesTotalValue } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-canvas py-16 md:py-24" data-id="element-12" data-mp="pm2axu5bnbfz">
      <div className="mx-auto w-full max-w-narrow px-5 md:px-8" data-id="element-13" data-mp="au1v6pqlckjy">
        <header className="text-center" data-id="element-14" data-mp="fu69c9411370">
          <h2 className="inline-flex items-center gap-3 font-display text-[1.75rem] font-extrabold leading-tight tracking-tight text-ink md:text-4xl" data-id="element-15" data-mp="fsv8oi5vobk4">
            <GiftIcon className="h-7 w-7 shrink-0 text-forest-600" aria-hidden="true" data-id="element-16" data-mp="5w0da84wira2" />6 bonos
            exclusivos
          </h2>
          <p className="mt-3 text-base text-gray-500" data-id="element-17" data-mp="3o2eldqgho70j">
            Valor total{' '}
            <span className="font-semibold text-gray-400 line-through" data-id="element-18" data-mp="3t06gsugceb9h">{bonusesTotalValue}</span> —
            incluido hoy <span className="font-bold text-forest-600" data-id="element-19" data-mp="1m9yvtb7sksx0">GRATIS</span> en el precio
          </p>
        </header>

        <ul className="mt-10 space-y-4" data-id="element-20" data-mp="1r80dpsthem6w">
          {bonuses.map((bonus, index) => <li key={bonus.tag} className="relative flex items-center gap-5 rounded-2xl bg-white px-5 py-5 shadow-soft md:gap-7 md:px-7" data-id="element-21" data-mp="3idn163zkpjj8" data-mpi={index}>
              <span className="absolute -left-3 flex h-7 w-7 items-center justify-center rounded-full bg-forest-600 font-sans text-xs font-bold text-white md:-left-4 md:h-8 md:w-8 md:text-sm" aria-hidden="true" data-id="element-22" data-mp="3r6i3opxnp15b">
                {index + 1}
              </span>

              {bonus.image ? <img src={bonus.image} alt={`Mockup del ${bonus.tag}: ${bonus.title}`} className="h-24 w-20 shrink-0 object-contain md:h-28 md:w-24" loading="lazy" data-id="element-23" data-mp="2ui22txp3j5cw" /> : <span className="flex h-24 w-20 shrink-0 flex-col items-center justify-center gap-1 rounded-lg border border-dashed border-gray-300 bg-canvas text-gray-400 md:h-28 md:w-24" aria-hidden="true" data-id="element-24" data-mp="np8cmlh4njld">
                  <ImageIcon className="h-5 w-5" data-id="element-25" data-mp="3hhzlbf3gi5cc" />
                  <span className="px-1 text-center text-[0.6rem] font-semibold leading-tight" data-id="element-26" data-mp="3hgohxgdxazlr">
                    Mockup
                  </span>
                </span>}

              <div className="min-w-0" data-id="element-27" data-mp="3qhmoo6fqxl81">
                <h3 className="font-display text-base font-extrabold leading-snug tracking-tight text-ink md:text-lg" data-id="element-28" data-mp="3qglc1xj30qo7">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-gray-500" data-id="element-29" data-mp="2xutmdjmpkdvx">{bonus.lead}</p>
                <p className="mt-2 font-sans text-sm font-bold" data-id="element-30" data-mp="32s21fbck81sy">
                  <span className="text-gray-400 line-through" data-id="element-31" data-mp="37jjvdfg6124f">valor {bonus.value}</span>{' '}
                  <span className="text-forest-600" data-id="element-32" data-mp="2a4ph77tvg62t">GRATIS</span>
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}